import get from 'lodash/get';

import type { AppConfig } from './types/AppConfig';

let config: AppConfig;

/**
 * @deprecated
 *
 * This function does not work during SSR and is prone to being used incorrectly.
 * We must set `config` before using it and there is no way to ensure that
 * programmatically.
 *
 * Use the hook `useAppConfig()` instead
 */
export function legacyHypernovaConfigValue(
  ...path: string[]
): string | null | undefined {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return get(config, path);
}

/**
 * @deprecated
 *
 * This is only used by hypernova and will be removed after the horizon
 * migration is complete
 */
export function legacyHypernovaSetConfigOnce(newConfig: AppConfig) {
  if (!config) {
    config = newConfig;
  }
}

/**
 * @deprecated
 *
 * This is only used by hypernova and will be removed after the horizon
 * migration is complete
 */
export function legacyHypernovaGetConfigForFetchUserEnvironment() {
  return config;
}
